import { render, staticRenderFns } from "./ClosePallet.vue?vue&type=template&id=b228b826"
import script from "./ClosePallet.vue?vue&type=script&lang=js"
export * from "./ClosePallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports